import { render, staticRenderFns } from "./PackMaterialManage.vue?vue&type=template&id=1aa2ac30&scoped=true&"
import script from "./PackMaterialManage.vue?vue&type=script&lang=js&"
export * from "./PackMaterialManage.vue?vue&type=script&lang=js&"
import style0 from "./PackMaterialManage.vue?vue&type=style&index=0&id=1aa2ac30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2ac30",
  null
  
)

export default component.exports